import request from './request';

const subscriptionPlanClassService = {
  // Récupérer les classes disponibles dans le plan
  getClasses: async (planSlug) => {
    try {
      const response = await request.get(`/subscription-plans/${planSlug}/classes`);
      return {
        success: true,
        data: response.data?.data || [],
        message: response.data?.message || 'Classes du plan récupérées avec succès'
      };
    } catch (error) {
      console.error('Erreur lors de la récupération des classes du plan:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la récupération des classes du plan'
      };
    }
  },

  // Ajouter des classes au plan
  addClasses: async (planSlug, classIds) => {
    console.log({
        classe_ids: classIds
      })
    try {
      const response = await request.post(`/subscription-plans/${planSlug}/classes`, {
        classe_ids: classIds
      });
      return {
        success: true,
        data: response.data?.data || {},
        message: response.data?.message || 'Classes ajoutées au plan avec succès'
      };
    } catch (error) {
      console.error('Erreur lors de l\'ajout des classes au plan:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de l\'ajout des classes au plan'
      };
    }
  },

  // Retirer une classe du plan
  removeClass: async (planSlug, classeId) => {
    try {
      const response = await request.delete(`/subscription-plans/${planSlug}/classes/${classeId}`);
      return {
        success: true,
        message: response.data?.message || 'Classe retirée du plan avec succès'
      };
    } catch (error) {
      console.error('Erreur lors de la suppression de la classe du plan:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la suppression de la classe du plan'
      };
    }
  }
};

export default subscriptionPlanClassService;
